/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { t, calc5Ext, calcCommon } from '../../utils/calculatorTranslations'
import { PageContext } from '../../context/PageContextProvider'
import { useParams, Link } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react'
import { Attention, Info } from '../../icons'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import jsPDF from 'jspdf'
import { font } from '../../utils/font'
import { getWatermarkDataUrl } from '../../utils/watermark'
import { calculateSickLeaveBenefit2026 } from '../Calculator5/sickLeaveCalculator2026'

const formatCurrency = (val) => {
  const num = Number(val) || 0
  const [int, dec] = num.toFixed(2).split('.')
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec + ' ₼'
}

const Result5 = ({ className }) => {
  const params = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [calcData, setCalcData] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        await PagesAPI.getMagazinePageInfo()
      } catch (e) {}

      // Try reading from sessionStorage
      let stored = null
      try {
        const raw = sessionStorage.getItem('sickleave_result_2026')
        if (raw) stored = JSON.parse(raw)
      } catch (e) {}

      if (stored && stored.eligibility) {
        setCalcData(stored)
      } else {
        // Fallback default calculation
        const defaultResult = calculateSickLeaveBenefit2026({
          eventStartDate: '2026-09-15',
          eventEndDate: '2026-09-30',
          caseType: 'ORDINARY_ILLNESS',
          employerFaultStatus: 'UNKNOWN',
          seniorityYears: 2,
          seniorityMonths: 4,
          seniorityDays: 10,
          monthlySalary: 1500,
          quarterlyEarnings: {
            '2025_Q3': 4500,
            '2025_Q4': 4500,
            '2026_Q1': 4500,
            '2026_Q2': 4500,
          },
          excludedDaysList: [],
          isContinuation: false,
          previouslyPaidEmployerDays: 0,
        })
        setCalcData(defaultResult)
      }
      setLoad(true)
    })()
  }, [params])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const generatePdf = async () => {
    if (!calcData) return

    const watermarkData = await getWatermarkDataUrl()
    const pdf = new jsPDF('p', 'mm', 'a4')
    pdf.addFileToVFS('WorkSans-normal.ttf', font)
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal')
    pdf.setFont('WorkSans')

    // Watermark Background
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    // Header
    pdf.setFillColor(22, 111, 229)
    pdf.rect(0, 0, 210, 20, 'F')
    pdf.setTextColor(255, 255, 255)
    pdf.setFontSize(13)
    pdf.setFont('WorkSans', 'normal')
    pdf.text('BPG CONSULTING — RƏSMİ HESABLAMA PROTOKOLU', 14, 13)

    pdf.setTextColor(15, 23, 42)
    pdf.setFontSize(14)
    pdf.text('Xəstəlik Vərəqəsi (Bülleten) Müavinəti Hesabatı (2026)', 14, 30)

    pdf.setFontSize(9)
    pdf.setTextColor(100, 116, 139)
    pdf.text(`Tarix: ${new Date().toLocaleDateString('az-AZ')} | Qayda: AR NK 189 nömrəli Qərar`, 14, 36)

    // Table 1: Əsas Göstəricilər
    let y = 46
    pdf.setFontSize(10)
    pdf.setTextColor(15, 23, 42)
    pdf.text('1. Hesablamanın Əsas Göstəriciləri', 14, y)
    y += 5

    pdf.setFillColor(241, 245, 249)
    pdf.rect(14, y, 182, 7, 'F')
    pdf.setFontSize(9)
    pdf.setTextColor(71, 85, 105)
    pdf.text('Parametr', 16, y + 5)
    pdf.text('Göstərici', 120, y + 5)
    y += 7

    const summaryRows = [
      ['Xəstəlik dövrü', `${calcData.inputs.eventStartDate} - ${calcData.inputs.eventEndDate} (${calcData.TGS} təqvim günü)`],
      ['Hadisənin növü', calcData.inputs.caseType === 'OCCUPATIONAL_ACCIDENT_OR_DISEASE' ? 'İstehsalat qəzası / peşə xəstəliyi' : 'Ümumi xəstəlik / məişət zədəsi'],
      ['Sosial sığorta stajı', `${calcData.inputs.seniorityYears} il ${calcData.inputs.seniorityMonths} ay ${calcData.inputs.seniorityDays} gün`],
      ['Müavinət hüququ / Ödəniş faizi', `${calcData.eligibility.rateLabel}`],
      ['4 rüb üzrə baza qazancı', formatCurrency(calcData.totalEarnings4Quarters)],
      ['Bölən təqvim günləri (BTG)', `${calcData.BTG} gün`],
      ['Bir günlük orta qazanc (OQM)', `${calcData.dailyRateOQM} AZN / gün`],
      ['İşəgötürənin payı (İlk 14 günədək)', `${calcData.employerDays} gün — ${formatCurrency(calcData.employerShareGross)}`],
      ['DSMF payı (15-ci gündən)', `${calcData.dsmfDays} gün — ${formatCurrency(calcData.dsmfShareGross)}`],
      ['Cəmi Brüt Müavinət', formatCurrency(calcData.grossBenefit)],
      ['Təxmini Gəlir Vergisi (VM 102.1.4)', formatCurrency(calcData.taxSimulation.totalEstimatedTax)],
      ['Təxmini Xalis Ödəniş', formatCurrency(calcData.grossBenefit - calcData.taxSimulation.totalEstimatedTax)],
    ]

    summaryRows.forEach(([param, val]) => {
      pdf.setTextColor(30, 41, 59)
      pdf.text(param, 16, y + 5)
      pdf.setFont('WorkSans', 'normal')
      pdf.text(val, 120, y + 5)
      pdf.setDrawColor(241, 245, 249)
      pdf.line(14, y + 7, 196, y + 7)
      y += 6.5
    })

    y += 8
    pdf.setFontSize(10)
    pdf.setTextColor(15, 23, 42)
    pdf.text('2. Maliyyələşmə Mənbələri Bölgüsü', 14, y)
    y += 5

    pdf.setFillColor(241, 245, 249)
    pdf.rect(14, y, 182, 7, 'F')
    pdf.setFontSize(8.5)
    pdf.setTextColor(71, 85, 105)
    pdf.text('Mənbə', 16, y + 5)
    pdf.text('Günlər', 80, y + 5)
    pdf.text('Gündəlik OQM', 110, y + 5)
    pdf.text('Brüt Məbləğ', 160, y + 5)
    y += 7

    const splitRows = [
      ['İşəgötürən vəsaiti (İlk 14 günədək)', `${calcData.employerDays} gün`, `${calcData.dailyRateOQM} AZN`, formatCurrency(calcData.employerShareGross)],
      ['DSMF vəsaiti (15-ci gündən)', `${calcData.dsmfDays} gün`, `${calcData.dailyRateOQM} AZN`, formatCurrency(calcData.dsmfShareGross)],
      ['YEKUN CƏMİ', `${calcData.TGS} gün`, '-', formatCurrency(calcData.grossBenefit)],
    ]

    splitRows.forEach(([src, days, oqm, amt], idx) => {
      if (idx === splitRows.length - 1) {
        pdf.setFillColor(248, 250, 252)
        pdf.rect(14, y, 182, 7, 'F')
        pdf.setTextColor(15, 23, 42)
      } else {
        pdf.setTextColor(51, 65, 85)
      }
      pdf.text(src, 16, y + 5)
      pdf.text(days, 80, y + 5)
      pdf.text(oqm, 110, y + 5)
      pdf.text(amt, 160, y + 5)
      y += 7
    })

    // Disclaimer footer
    y += 12
    pdf.setFontSize(8)
    pdf.setTextColor(100, 116, 139)
    pdf.text('Qanunvericilik Qeydi: AR NK 189 nömrəli Qərarı. VM 102.1.4 üzrə müavinətdən gəlir vergisi tutulur,', 14, y)
    pdf.text('SSQ m.15 üzrə MDSS, İTS və İŞS tutulmur (0%). Bu hesablama yalnız təxmini simulyasiya xarakterlidir.', 14, y + 4)

    pdf.save(`BPG_Bülleten_Müavinəti_${calcData.inputs.eventStartDate}.pdf`)
  }

  if (!load) return <Loading />
  if (!calcData) return null

  const isEligible = calcData.eligibility.eligible
  const estNet = Math.max(0, calcData.grossBenefit - (calcData.taxSimulation?.totalEstimatedTax || 0))

  return (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={2} data={steps} />
      </div>

      <h1 className={styles.pageTitle}>
        {translate.sick_leave?.[language] || 'Əmək qabiliyyətinin müvəqqəti itirilməsinə görə müavinət hesabatı (2026)'}
      </h1>

      {/* 1 İllik Limit Aşılması Xəbərdarlığı (TC-26) */}
      {calcData.isMaxPeriodExceeded && (
        <div className={styles.alertWarning} style={{ background: '#fffbe6', borderColor: '#ffe58f' }}>
          <Attention className={styles.alertIcon} />
          <div>
            <h4 style={{ color: '#874d00' }}>Maksimum Müavinət Müddəti Xəbərdarlığı (1 İl Həddi — Qayda bənd 1.4)</h4>
            <p style={{ color: '#d46b08' }}>
              {calcData.legalNotices?.maxPeriodWarning ||
                'Qayda bənd 1.4: Müavinət əmək qabiliyyəti bərpa olunanadək və ya TSEK tərəfindən əlillik müəyyən edilənədək, lakin bir ildən çox olmayan dövr üçün verilir (365 təqvim günündən artıq dövr üçün TSEK əlillik qiymətləndirməsi aparılmalıdır).'}
            </p>
          </div>
        </div>
      )}

      {/* Seniority / Eligibility Status Banner */}
      {!isEligible ? (
        <div className={styles.alertWarning} style={{ background: '#fff1f0', borderColor: '#ffa39e' }}>
          <Attention className={styles.alertIcon} style={{ color: '#cf1322' }} />
          <div>
            <h4 style={{ color: '#cf1322' }}>Müavinət Hüququ Yaranmır (Qayda 1.5)</h4>
            <p style={{ color: '#a8071a' }}>
              İşçinin sosial sığorta stajı 6 aydan az olduğu üçün (faktiki staj: {calcData.inputs.seniorityYears} il {calcData.inputs.seniorityMonths} ay {calcData.inputs.seniorityDays} gün),
              qüvvədə olan qanunvericiliyə əsasən əmək qabiliyyətinin müvəqqəti itirilməsinə görə müavinət hesablanmır (0.00 AZN).
            </p>
          </div>
        </div>
      ) : (
        <div className={styles.alertWarning} style={{ background: '#f6ffed', borderColor: '#b7eb8f' }}>
          <Info className={styles.alertIcon} style={{ color: '#52c41a' }} />
          <div>
            <h4 style={{ color: '#135200' }}>Müavinət Hüququ Təsdiqlənmişdir (100% Ödəniş)</h4>
            <p style={{ color: '#237804' }}>
              Sosial sığorta stajı 6 aydan çoxdur. 2026-cı il qaydalarına uyğun olaraq müavinət hüququ yarandıqda
              iş stajından asılı olmayaraq 100% miqdarında hesablanır (Qayda 1.5).
            </p>
          </div>
        </div>
      )}

      {/* Occupational Notice Banner */}
      {calcData.inputs.caseType === 'OCCUPATIONAL_ACCIDENT_OR_DISEASE' && (
        <div className={styles.alertWarning}>
          <Attention className={styles.alertIcon} />
          <div>
            <h4>İstehsalat Qəzası və ya Peşə Xəstəliyi Xüsusi Rejimi</h4>
            <p>
              {calcData.inputs.employerFaultStatus === 'CONFIRMED'
                ? 'Qayda 2.17: Rəsmi İZ aktı ilə sığortaedənin təqsiri təsdiq edildiyi üçün bütün dövr (100%) işəgötürənin vəsaiti hesabına ödənilir.'
                : calcData.inputs.employerFaultStatus === 'UNKNOWN'
                ? 'Xəbərdarlıq: Sığortaedənin təqsir statusu hələ müəyyən edilməmişdir (İZ aktı tərtib olunmayıb). 2x vəzifə maaşı tavanı tətbiq edilməmiş, 25x minimum pensiya tavanı (8 000 AZN) qorunmuşdur.'
                : 'İşəgötürənin təqsiri müəyyən edilmədiyi üçün standart maliyyələşmə bölgüsü tətbiq edilmişdir.'}
            </p>
          </div>
        </div>
      )}

      {/* Top 4 KPI Cards */}
      <div className={styles.resultGrid}>
        <div className={`${styles.statCard} ${styles.heroCardA}`}>
          <div>
            <div className={styles.cardLabel}>Cəmi Brüt (Gross) Müavinət</div>
            <div className={`${styles.cardValue} ${styles.primary}`}>
              {formatCurrency(calcData.grossBenefit)}
            </div>
          </div>
          <div className={styles.cardSub}>
            Cəmi {calcData.TGS} təqvim günü üzrə qanuni hesablanmış ümumi müavinət
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>{t(calc5Ext.employerPaidShare, language)}</div>
            <div className={styles.cardValue}>
              {formatCurrency(calcData.employerShareGross)}
            </div>
          </div>
          <div className={styles.cardSub}>
            İlk 14 təqvim günü ({calcData.employerDays} gün) — Müəssisə vəsaiti hesabına
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>{t(calc5Ext.dsmfPaidShare, language)}</div>
            <div className={styles.cardValue}>
              {formatCurrency(calcData.dsmfShareGross)}
            </div>
          </div>
          <div className={styles.cardSub}>
            15-ci gündən sonrakı dövr ({calcData.dsmfDays} gün) — Dövlət büdcəsi / DSMF
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.heroCardB}`}>
          <div>
            <div className={styles.cardLabel}>Təxmini Xalis Ödəniş (Net)</div>
            <div className={`${styles.cardValue} ${styles.success}`}>
              {formatCurrency(estNet)}
            </div>
          </div>
          <div className={styles.cardSub}>
            VM 102.1.4 üzrə gəlir vergisi çıxıldıqdan sonra (MDSS, İTS, İŞS = 0%)
          </div>
        </div>
      </div>

      {/* CƏDVƏL 1: Maliyyələşmə Bölgüsü */}
      <div className={styles.auditSection}>
        <div className={styles.auditTitle}>
          <span>{t(calc5Ext.financingSourcesDays, language)}</span>
          <span className={styles.badge}>AR NK 189 Qərarı (Bənd 2.5)</span>
        </div>

        <div className={styles.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>{t(calc5Ext.financingSource, language)}</th>
                <th className="num">Təqvim Günləri</th>
                <th className="num">Gündəlik Norma (OQM)</th>
                <th className="num">Brüt Məbləğ</th>
                <th>Qanunvericilik Əsası</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="bold">İşəgötürənin vəsaiti (İlk 14 günədək)</td>
                <td className="num">{calcData.employerDays} gün</td>
                <td className="num">{calcData.dailyRateOQM} AZN</td>
                <td className="num bold">{formatCurrency(calcData.employerShareGross)}</td>
                <td>AR NK 189 Qərarı, bənd 2.5</td>
              </tr>
              <tr>
                <td className="bold">DSMF vəsaiti (15-ci gündən etibarən)</td>
                <td className="num">{calcData.dsmfDays} gün</td>
                <td className="num">{calcData.dailyRateOQM} AZN</td>
                <td className="num bold">{formatCurrency(calcData.dsmfShareGross)}</td>
                <td>AR NK 189 Qərarı, bənd 2.5 / SSQ m.14</td>
              </tr>
              <tr className={styles.totalRow}>
                <td>YEKUN CƏMİ MÜAVİNƏT</td>
                <td className="num">{calcData.TGS} gün</td>
                <td className="num">-</td>
                <td className="num bold">{formatCurrency(calcData.grossBenefit)}</td>
                <td>Qayda 1.5 (100% təminat)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* CƏDVƏL 2: Aylıq Bölünmə və Tavan Yoxlanışı */}
      <div className={styles.auditSection}>
        <div className={styles.auditTitle}>
          <span>Aylıq Bölünmə və Tavan Limitlərinin Yoxlanışı</span>
          <span className={styles.badge}>Bənd 2.10.1 & 2.10.2 Tavan Nəzarəti</span>
        </div>

        <div className={styles.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>Ay</th>
                <th className="num">Ayın Təqvim Günləri</th>
                <th className="num">Bülleten Günləri</th>
                <th className="num">İşəgötürən Günləri</th>
                <th className="num">DSMF Günləri</th>
                <th className="num">Gündəlik Norma</th>
                <th className="num">Tavan Tətbiq Edilib?</th>
                <th className="num">Aylıq Brüt Müavinət</th>
              </tr>
            </thead>
            <tbody>
              {calcData.monthlyBreakdown?.map((m) => (
                <tr key={m.monthKey}>
                  <td className="bold">{m.monthKey}</td>
                  <td className="num">{m.totalCalendarDaysInMonth} gün</td>
                  <td className="num">{m.sickDaysInMonth} gün</td>
                  <td className="num">{m.employerDays} gün</td>
                  <td className="num">{m.dsmfDays} gün</td>
                  <td className="num">{m.effectiveDailyRate} AZN</td>
                  <td className="num">
                    {m.isCapApplied ? (
                      <span style={{ color: '#d97706', fontWeight: 700 }}>Bəli (Tavan tətbiq edildi)</span>
                    ) : (
                      <span style={{ color: '#059669' }}>Xeyr (Tavan daxilindədir)</span>
                    )}
                  </td>
                  <td className="num bold">{formatCurrency(m.monthGross)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* CƏDVƏL 3: Layer 2 Təxmini Payroll Vergi Rekonsilyasiyası (Simulyasiya) */}
      {calcData.taxSimulation?.months?.length > 0 && (
        <div className={styles.auditSection}>
          <div className={styles.auditTitle}>
            <span>Layer 2: Təxmini Payroll Vergi Rekonsilyasiyası (Simulyasiya)</span>
            <span className={styles.badge}>Məlumatlandırma Xarakterli İlkin Simulyasiya</span>
          </div>

          <div style={{ background: '#f8fafc', borderLeft: '4px solid #166fe5', padding: '14px 16px', borderRadius: '6px', marginBottom: '20px', fontSize: '13px', color: '#475569', lineHeight: '1.6' }}>
            <strong>💡 Vergi və Sığorta Rekonsilyasiyası Qaydası:</strong>
            <br />
            1. <strong>Gəlir Vergisi:</strong> VM 102.1.4-ə əsasən bülleten məbləğindən (həm işəgötürən, həm DSMF hissəsindən) gəlir vergisi tutulur.
            <br />
            2. <strong>Sosial Sığorta Azadlığı:</strong> "Sosial sığorta haqqında" Qanunun 15-ci maddəsi, İTS Qanununun 15-10-cu maddəsi və İŞS Qanununun 9-cu maddəsinə əsasən xəstəlik müavinətindən MDSS, İTS və İŞS tutulmur (0%).
            <br />
            3. <strong>200 AZN Güzəşt:</strong> VM 102.1.6 üzrə 200 AZN vergi güzəşti ay üzrə ümumi muzdlu gəlirə yalnız bir dəfə tətbiq olunur.
            <br />
            4. <strong>⚠️ Uçot Qeydi:</strong> Bu hesablama yalnız təxmini vergi rekonsilyasiyası (simulyasiyası) xarakteri daşıyır və mühasibat proqramının rəsmi əməkhaqqı bordrosunu və ya vergi bəyannaməsini birbaşa əvəz etmir.
          </div>

          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Ay</th>
                  <th className="num">İşlənmiş Maaş</th>
                  <th className="num">Məzuniyyət Haqqı</th>
                  <th className="num">Bülleten Müavinəti</th>
                  <th className="num">Cəmi Muzdlu Gəlir</th>
                  <th className="num">Gəlir Vergisi</th>
                  <th className="num">MDSS (Maaş)</th>
                  <th className="num">İTS (Maaş)</th>
                  <th className="num">İŞS (Maaş)</th>
                </tr>
              </thead>
              <tbody>
                {calcData.taxSimulation.months.map((tm) => (
                  <tr key={tm.monthKey}>
                    <td className="bold">{tm.monthKey}</td>
                    <td className="num">{formatCurrency(tm.baseSalary)}</td>
                    <td className="num">{formatCurrency(tm.vacationPay)}</td>
                    <td className="num bold" style={{ color: '#166fe5' }}>{formatCurrency(tm.sickBenefit)}</td>
                    <td className="num bold">{formatCurrency(tm.totalMonthlyEmploymentIncome)}</td>
                    <td className="num" style={{ color: '#dc2626' }}>{formatCurrency(tm.monthlyIncomeTax)}</td>
                    <td className="num">{formatCurrency(tm.mdssOnSalaryAndVacation)}</td>
                    <td className="num">{formatCurrency(tm.itsOnSalaryAndVacation)}</td>
                    <td className="num">{formatCurrency(tm.issOnSalaryAndVacation)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Hüquqi Məsuliyyət və Metodiki İzah */}
      <div className={styles.disclaimerCard}>
        <h4>Hüquqi və Metodiki Qeydlər</h4>
        <p>
          1. <strong>Qanunvericilik Bazası:</strong> AR Nazirlər Kabinetinin 189 nömrəli Qərarı ilə təsdiq edilmiş "Məcburi dövlət sosial sığortası üzrə ödəmələrin və əmək qabiliyyətini müvəqqəti itirmiş işçilərə sığortaedənin vəsaiti hesabına ödənilən müavinətin təyin edilməsi və verilməsi Qaydası", AR Vergi Məcəlləsi (maddə 98, 101.1-1, 102.1.4, 102.1.6) və "Sosial sığorta haqqında" AR Qanunu (maddə 14, 15).
        </p>
        <p>
          2. <strong>01.05.2026 Dəyişikliyi:</strong> 01 may 2026-cı il tarixindən etibarən əmək stajına görə 60%, 80%, 100% fərqləndirmə ləğv edilmişdir. Ən azı 6 ay sosial sığorta stajı olduqda müavinət 100% miqdarında hesablanır (Qayda 1.5).
        </p>
        <p>
          3. <strong>Tutulmalar:</strong> VM 102.1.4-cü maddəsinə əsasən əmək qabiliyyətinin müvəqqəti itirilməsinə görə müavinətlər gəlir vergisindən azad edilməyən gəlirlərə aiddir. "Sosial sığorta haqqında" Qanunun 15-ci maddəsinə əsasən isə bu müavinətdən məcburi dövlət sosial sığorta haqqı, eləcə də İTS və İŞS tutulmur.
        </p>
        <p>
          4. <strong>Əmək Məcəlləsinin 131-ci maddəsi:</strong> İşçinin əmək məzuniyyəti dövründə əmək qabiliyyəti müvəqqəti itirildikdə, məzuniyyət xəstəlik vərəqəsində göstərilən günlərin sayına uyğun olaraq uzadılır və ya tərəflərin razılığı ilə başqa vaxta keçirilir.
        </p>
        <p>
          5. <strong>Elektron Xəstəlik Vərəqəsi (MEİS):</strong> AR NK 189 nömrəli Qərarı bənd 1.3-ə əsasən, müavinət tibb müəssisəsinin elektron formada tərtib etdiyi və Əmək və Əhalinin Sosial Müdafiəsi Nazirliyinin mərkəzləşdirilmiş elektron informasiya sisteminə (MEİS) ötürdüyü elektron xəstəlik vərəqəsi məlumatlarına əsasən təyin edilir.
        </p>
        <p>
          6. <strong>Maksimum Müddət Həddi (Qayda bənd 1.4):</strong> Müavinət əmək qabiliyyəti bərpa olunanadək və ya TSEK tərəfindən əlillik müəyyən edilənədək, lakin bir ildən çox olmayan dövr üçün verilir.
        </p>
      </div>

      {/* Button Group */}
      <div className={styles.btnGroup}>
        <button type="button" className={styles.btnPrimary} onClick={generatePdf}>
          Rəsmi Hesabatı Yüklə (PDF)
        </button>
        <Link to="/useful/calculator/5" className={styles.btnSecondary}>
          Yeni Hesablama Apar
        </Link>
        <Link to="/useful/calculator" className={styles.btnSecondary}>
          Bütün Kalkulyatorlar
        </Link>
      </div>
    </section>
  )
}

export default Result5
